import React from "react";
import {
    Box,
    Checkbox,
    Collapse,
    IconButton,
    Stack,
    TableCell,
    TableRow,
    Tooltip,
    Typography
} from "@mui/material";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

import BadgeStatusIntegracao from "./BadgeStatusIntegracao";
import CampoEdicaoInline from "./CampoEdicaoInline";
import MenuAcoesIntegracao from "./MenuAcoesIntegracao";
import SubgradeServicosRevenda from "./SubgradeServicosRevenda";

import { AMARELO_ALTERADO, SUPERFICIE, bloqueadoPorStatus, formatarDia, formatarMoeda } from "./utils";

const LinhaIntegracaoRevenda = ({
    item,
    tiposServico,
    expandida,
    selecionada,
    somenteLeitura = false,
    onExpandir,
    onSelecionar,
    onSalvarCodigoRevenda,
    onSalvarCodigoServico,
    onSalvarTipoServico,
    onVerClientes,
    onConfirmar,
    onIntegrar,
    onDesconfirmar,
    onIgnorar,
    onReconsiderar,
    onVerHistorico
}) => {
    const corFundo = item.alterado ? AMARELO_ALTERADO : undefined;
    const edicaoBloqueada = somenteLeitura || bloqueadoPorStatus(item.statusOS);

    return (
        <>
            <TableRow
                hover
                sx={{
                    backgroundColor: corFundo,
                    "& > td": { borderBottom: expandida ? "none" : undefined }
                }}
            >
                <TableCell>
                    <IconButton
                        size="small"
                        onClick={onExpandir}
                        aria-label={expandida ? "Recolher" : "Expandir"}
                    >
                        {expandida
                            ? <KeyboardArrowDownIcon fontSize="small" />
                            : <KeyboardArrowRightIcon fontSize="small" />}
                    </IconButton>
                </TableCell>

                <TableCell padding="checkbox">
                    <Checkbox
                        checked={selecionada}
                        onChange={onSelecionar}
                        disabled={somenteLeitura}
                        inputProps={{ "aria-label": `Selecionar ${item.distribuidorNome}` }}
                    />
                </TableCell>

                <TableCell>
                    <Stack direction="row" spacing={0.5} alignItems="center">
                        <Typography variant="body2" fontWeight={500}>
                            {item.distribuidorNome}
                        </Typography>
                        {!item.completo && (
                            <Tooltip title={item.motivoIncompleto || "Faturamento incompleto"}>
                                <PriorityHighIcon
                                    fontSize="smaller"
                                    color="warning"
                                    aria-label="Faturamento incompleto"
                                />
                            </Tooltip>
                        )}
                    </Stack>
                </TableCell>

                <TableCell>
                    <CampoEdicaoInline
                        valor={item.codigoIntegracaoSISDM}
                        disabled={!item.faturamentoIds?.length || edicaoBloqueada}
                        ariaLabel={`Código SISDM de ${item.distribuidorNome}`}
                        onSalvar={(valor) => onSalvarCodigoRevenda(item, valor)}
                    />
                </TableCell>

                <TableCell align="center">{formatarDia(item.diaFaturamento)}</TableCell>
                <TableCell align="center">{formatarDia(item.diaVencimento)}</TableCell>

                <TableCell align="right">
                    <Typography variant="body2" fontWeight={500}>
                        {formatarMoeda(item.totalFaturamento)}
                    </Typography>
                </TableCell>

                <TableCell align="center">
                    <BadgeStatusIntegracao status={item.statusOS} />
                </TableCell>

                <TableCell align="center">
                    <MenuAcoesIntegracao
                        statusOS={item.statusOS}
                        completo={item.completo}
                        temOS={Boolean(item.osId)}
                        somenteLeitura={somenteLeitura}
                        temHistorico={Boolean(item.osId)}
                        onConfirmar={() => onConfirmar(item)}
                        onIntegrar={() => onIntegrar(item)}
                        onDesconfirmar={() => onDesconfirmar(item)}
                        onIgnorar={() => onIgnorar(item)}
                        onReconsiderar={() => onReconsiderar(item)}
                        onVerHistorico={(anchor) => onVerHistorico(item, anchor)}
                    />
                </TableCell>
            </TableRow>

            <TableRow sx={{ backgroundColor: corFundo }}>
                <TableCell colSpan={9} sx={{ p: 0, borderBottom: expandida ? undefined : "none" }}>
                    <Collapse in={expandida} timeout="auto" unmountOnExit>
                        <Box sx={{ p: 2, backgroundColor: SUPERFICIE }}>
                            <SubgradeServicosRevenda
                                item={item}
                                tiposServico={tiposServico}
                                bloqueado={edicaoBloqueada}
                                onSalvarCodigoServico={onSalvarCodigoServico}
                                onSalvarTipoServico={onSalvarTipoServico}
                                onVerClientes={onVerClientes}
                            />
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

export default React.memo(LinhaIntegracaoRevenda);
